'use client'

/**
 * Visual indicator for the Staging environment.
 * Only renders when NEXT_PUBLIC_APP_ENV is explicitly 'staging'.
 */
export function StagingBanner() {
  const isStagingEnv = process.env.NEXT_PUBLIC_APP_ENV === 'staging'

  if (!isStagingEnv) return null

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: '#f59e0b', // Amber/Yellow
      color: '#000',
      textAlign: 'center',
      padding: '4px 12px',
      fontSize: '11px',
      fontWeight: '700',
      zIndex: 9999,
      letterSpacing: '0.05em',
      pointerEvents: 'none',
      borderTop: '1px solid rgba(0,0,0,0.1)',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      ⚠️ STAGING ENVIRONMENT — staging.zepelin.ma
    </div>
  )
}
